import * as React from 'react';

interface IProps {
    classes?: string;
    children: any;
}

export const PageBody = (props:IProps) => (
    <div className={"row " + (props.classes ? props.classes : '') }>
        <div className="col page-body-wrap">
            { props.children }
        </div>
    </div>
);
